import React from "react";
import cx from "classnames";

import { Twitter, BrandArrow } from "assets/media/svgs";

import Ima from "assets/media/images/customers/profiles/ima.png";
import Johnson from "assets/media/images/customers/profiles/johnson.png";

import * as styles from "./Testimonial.module.scss";

import { BRASS_WALL_OF_LOVE } from "data/config";

const Testimonial: React.FC = () => {
  return (
    <section className={styles.Testimonial}>
      <div className={styles.Testimonial_container}>
        <h3 className={styles.Testimonial_container_text}>
          Hear what our friends say on our Twitter wall of love
        </h3>
        <div className={styles.Testimonial_container_content}>
          <div className={styles.Testimonial_container_item}>
            <div className={styles.Testimonial_container_item_avatar}>
              <img src={Ima} alt="" />
              <div>
                <h4 className={styles.Testimonial_container_item_text}>Ima</h4>
                <p className={styles.Testimonial_container_item_handle}>
                  @sharonabak
                </p>
              </div>
            </div>
            <p className={styles.Testimonial_container_item_text}>
              As someone that absolutely hates going to the bank,{" "}
              <u>@brassbanking</u> was the perfect solution to getting my
              current account sorted with a few clicks. Patiently waiting for
              your app. Well done!
            </p>
          </div>
          <div className={styles.Testimonial_container_item}>
            <div className={styles.Testimonial_container_item_avatar}>
              <img src={Johnson} alt="" />
              <div>
                <h4 className={styles.Testimonial_container_item_text}>
                  Oliver de Johnson
                </h4>
                <p className={styles.Testimonial_container_item_handle}>
                  @oliverdjohnson
                </p>
              </div>
            </div>
            <p className={styles.Testimonial_container_item_text}>
              Every startup need a <u>@brassbanking</u> in their corner. We
              needed an urgent 500K. Sent a 1 liner email to brass and that was
              it.
            </p>
          </div>
          <div
            className={cx(
              styles.Testimonial_container_item,
              styles.Testimonial_container_link
            )}
          >
            <div className={styles.Testimonial_container_link_svg}>
              <Twitter />
            </div>

            <a
              target="_blank"
              rel="nofollow noreferrer"
              href={BRASS_WALL_OF_LOVE}
              className={styles.Testimonial_container_item_text}
            >
              See our wall of love <BrandArrow />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
